export default __webpack_public_path__ + "static/media/terrace3.c7198bcf.jpg";